<arm-dialog (onSubmit)="ok()"
            [hideCancelButton]="true"
            [title]="'Information'">
    <div mat-dialog-content class="content">
        {{data?.message}}
    </div>
</arm-dialog>
